import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import React, { Component } from 'react';
import { Card, Button, Segment, Image } from 'semantic-ui-react';

import './styles.css';

class CategoryCard extends Component {
  render() {
    return (
      <Card centered>
        <Card.Content>
          {this.props.src !== '' ? (
            <Link to={'/categories/' + this.props.id}>
              <Image src={this.props.src} />
            </Link>
          ) : null}
          <Segment basic className="category-meta-container">
            <Card.Content size="tiny"> {this.props.desc} </Card.Content>
            <Link to={'/products/' + this.props.id}>
              <Button color="orange" compact>
                Перейти к билетам &gt;
              </Button>
            </Link>
          </Segment>
        </Card.Content>
      </Card>
    );
  }
}

CategoryCard.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  src: PropTypes.string,
  desc: PropTypes.string.isRequired,
};

CategoryCard.defaultProps = {
  src: '',
};

export default CategoryCard;
